export class ContentSharingFacebookModel {
    url: string = '';

    constructor(
        url: string
    ) {
        this.url = url;
    }
}
